import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityStore } from '@argo/security';
import { AuthenticationStore } from '@argo/authentication';
import { CommonPhase } from '@argo/common';
import { 
  ScaModuleTitleComponent,
  ScaCardWorkshopComponent,
  ScaAlertComponent,
  ScaBadgeComponent,
  ScaIconComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-security-test-complete',
  standalone: true,
  imports: [
    CommonModule,
    ScaModuleTitleComponent,
    ScaCardWorkshopComponent,
    ScaAlertComponent,
    ScaBadgeComponent,
    ScaIconComponent
  ],
  templateUrl: './security-test-complete-redesigned.component.html',
  styleUrl: './security-test-complete-redesigned.component.scss'
})
export class SecurityTestCompleteComponent {
  readonly securityStore = inject(SecurityStore);
  readonly authStore = inject(AuthenticationStore);
  readonly CommonPhase = CommonPhase;
  readonly coverage = 100;
}
